import React from "react"

import { localizer } from "../../../Translator"

import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import { Button } from  "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Backdrop, CircularProgress } from "@material-ui/core"
import Chip from '@material-ui/core/Chip'

import FeedbackShipmentSummary from '../../inbox/sections/FeedbackShipmentSummary'

import { TableRowStyled, TableCellStyled } from '../../common/TableStyled.js'

import { SnackbarCustom } from "../../Utilities/SnackbarCustom";
import StateCodes from "../../Utilities/StateCodes.js";
import DateCustom from "../../Utilities/DateCustom.js"
import CurrencyCustom from "../../Utilities/CurrencyCustom.js"

import InboxCli from "../../../sdk/InboxCli";
import OutboxCli from "../../../sdk/OutboxCli";
import ProductCli from "../../../sdk/ProductCli";

export class BillingShipmentRow extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // BillingReportEntry model which contains the billing shipment data
      entry: {},

      // Shipment object which feedback belong to
      shipment: {},
      shipmentFeedbacks: [],

      states: [],
      certs: [],
      proofs: [],
      reports: [],
      documents: [],
      stampedCopies: [],

      trackings: [],
      trackingMain: [],
      trackingsDispatches: [],

      // Indicates if shipment summary of the feedback is open or closed
      openModal: false,

      // Error message in case API call fail
      errormessage: null,

      // Flag to determinate if row is expanded or collapsed
      open: false,

      // Flag to display circular progress when an API call is executing
      isLoading: false
    }
  }

  componentDidMount() {
    if (!this.props.shipment) return

    const trackingModel = this.buildTrackingModel(this.props.trackings)
    this.setState({
      shipment: this.props.shipment,
      trackings: trackingModel.trackings,
      trackingMain: trackingModel.trackingMain,
      trackingsDispatches: trackingModel.trackingsDispatches
    })
  }
  
  componentDidUpdate(prevProps) {
    if (this.props.shipment === prevProps.shipment &&
      this.props.trackings === prevProps.trackings) return

    const trackingModel = this.buildTrackingModel(this.props.trackings)
    this.setState({
      shipment: this.props.shipment,
      trackings: trackingModel.trackings,
      trackingMain: trackingModel.trackingMain,
      trackingsDispatches: trackingModel.trackingsDispatches
    })
  }

  // Builds the tracking state used by this row, following ShipmentRow in Outbox.
  buildTrackingModel = (trackingsProp) => {
    const trackings = Array.isArray(trackingsProp) ? [...trackingsProp] : []
    trackings.sort(this.sortByDate("assignedTime"))

    return {
      trackings,
      trackingMain: trackings.length > 0 ? trackings[0] : {},
      trackingsDispatches: trackings.length > 1 ? trackings.slice(1) : []
    }
  }

  /**
    * Gets feedbacks information of the shipment given 
    */
  getFeedbacksOfShipment = () => {
    if (!this.state.shipment || !this.state.shipment.shipmentCode) return

    InboxCli.GetFeedbackOfShipment(this.state.shipment.shipmentCode, true, true, true, true, true).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ errormessage: data.substring(data.indexOf(' ')) })
      } else {
        this.setState({ errormessage: null, shipmentFeedbacks: data },
          () => {
            this.getStatesInfo()
            this.getCertsInfo()
            this.getProofsInfo()
            this.getDocuments()
            this.getStampedCopies()
          })
      }
    })
  }

  /**
  * Gets states information of shipment to display it in the summary
  */
  getStatesInfo = () => {
    let retunsIds = this.state.shipmentFeedbacks ? this.state.shipmentFeedbacks.filter(f => f.returnType === InboxCli.RETURN_STAGE_STATE).map(f => f.returnId) : []
    if (retunsIds.length === 0) return

    InboxCli.GetStates(retunsIds).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ errormessage: data.substring(data.indexOf(' ')) })
      } else {
        data = data.map(st => {
          var temp
          if (st !== null) {
            temp = Object.assign({}, st)
            temp.stateData = JSON.parse(st.stateData)
          }
          return temp
        })

        let filtered = data.filter(d => d !== null && d.stage !== InboxCli.RETURN_STAGE_RETURN)
        if (filtered) filtered.sort(this.sortByDate("timestamp"))
        this.setState({ states: filtered, errormessage: null })
      }
    })
  }

  /**
   * Gets certs information of shipment to display it in the summary
   */
  getCertsInfo = () => {
    let retunsIds = this.state.shipmentFeedbacks ? this.state.shipmentFeedbacks.filter(f => f.returnType === InboxCli.RETURN_STAGE_CERT).map(f => f.returnId) : []
    if (retunsIds.length === 0) return

    InboxCli.GetCerts(retunsIds).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ errormessage: data.substring(data.indexOf(' ')) })
      } else {
        let filtered = data.filter(d => d !== null)
        if (filtered) filtered.sort(this.sortByDate("timestamp"))
        this.setState({ certs: filtered, errormessage: null })
      }
    })
  }

  /**
   * Gets proofs information of shipment to display
   */
  getProofsInfo = () => {
    let retunsIds = this.state.shipmentFeedbacks ? this.state.shipmentFeedbacks.filter(f => f.returnType === InboxCli.RETURN_STAGE_PROOF).map(f => f.returnId) : []
    if (retunsIds.length === 0) return

    InboxCli.GetProofs(retunsIds).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ errormessage: data.substring(data.indexOf(' ')), severity: "error" })
      } else {
        let filtered = data.filter(d => d !== null)
        if (filtered) filtered.sort(this.sortByDate("timestamp"))
        this.setState({ proofs: filtered, errormessage: null })
      }
    })
  }

  /**
   * Gets documents information of shipment to display
   */
  getDocuments = () => {
    let retunsIds = this.state.shipmentFeedbacks ? this.state.shipmentFeedbacks.filter(f => f.returnType === InboxCli.RETURN_STAGE_DOCUMENT).map(f => f.returnId) : []
    if (retunsIds.length === 0) return

    InboxCli.GetDocuments(retunsIds).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ errormessage: data.substring(data.indexOf(' ')), severity: "error" })
      } else {
        let filtered = data.filter(d => d !== null)
        if (filtered) filtered.sort(this.sortByDate("timestamp"))
        this.setState({ documents: filtered, errormessage: null })
      }
    })
  }

  /**
   * Gets stamped copies information of shipment to display
   */
  getStampedCopies = () => {
    let retunsIds = this.state.shipmentFeedbacks ? this.state.shipmentFeedbacks.filter(f => f.returnType === InboxCli.RETURN_STAGE_STAMPED_COPY).map(f => f.returnId) : []
    if (retunsIds.length === 0) return

    InboxCli.GetStampedCopy(retunsIds).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ errormessage: data.substring(data.indexOf(' ')), severity: "error" })
      } else {
        let filtered = data.filter(d => d !== null)
        if (filtered) filtered.sort(this.sortByDate("timestamp"))
        this.setState({ stampedCopies: filtered, errormessage: null })
      }
    })
  }

  /**
   * Set the state open / collapsed of Collapse elements for expandable rows.
   */
  setOpen = () => {
    this.setState({ open: !this.state.open },
      () => {
        if (this.state.open) {
          this.getFeedbacksOfShipment()
        }
      })
  }
  
  /**
   * Set the state open of shipment summary dialog.
  */
  handleOpenModal = () => {
    this.setState({ openModal: true })
  }

  /**
   * Set the state closed of shipment summary dialog.
  */
  handleCloseModal = () => {
    this.setState({ openModal: false })
  }

  mountDestinationAddress = () => {
    if (!this.state.shipment) return ""
    if (!this.state.shipment.destinationAddress) return ""
    
    let destinationaddress = this.state.shipment.destinationAddress.who + "\n" +
      this.state.shipment.destinationAddress.streetType + " " + this.state.shipment.destinationAddress.streetName + " " + this.state.shipment.destinationAddress.streetNumber + " " + this.state.shipment.destinationAddress.streetComplements + "\n" +
      this.state.shipment.destinationAddress.postalCode + " " + this.state.shipment.destinationAddress.locality
    return destinationaddress
  }

  mountDestinationAddressWho = () => {
    if (!this.state.shipment) return ""
    if (!this.state.shipment.destinationAddress) return ""
    
    let who = this.state.shipment.destinationAddress.who
    return who
  }

  /**
   * sort json by date atribute asc
   */
  sortByDate(prop) {
    return function (a, b) {
      if (a && b) {
        var a2 = Date.parse(a[prop].substring(0, 23) + a[prop].substring(26));
        var b2 = Date.parse(b[prop].substring(0, 23) + b[prop].substring(26));
        return new Date(a2).getTime() - new Date(b2).getTime()
      }
    }
  }

  /**
 * get url to logistic operator
 */
  getUrlOperator = (tracking) => {
    if (!tracking) return ''
    let products = ["PQ", "PK", "NB", "CD", ...ProductCli.SIDI_PRODUCT_CODE];
    let codTracking = tracking.codeValue
    let initTracking = codTracking && codTracking.slice(0, 2);
    const url = products.includes(initTracking) ?
      'https://www.correos.es/es/es/herramientas/localizador/envios/detalle?tracking-number=' + codTracking : ''
    return url
  }

  getProductDescription = (productCode) => {
    let description = ""
    this.props.products && this.props.products.forEach(product => {
      if (product.productCode === productCode) {
        description = product.description
        return
      }
    })
    return description
  }

  /**
   * download the file associated to feedback
  */
  downloadFeedbackFile = (event) => {
    let returnId = event.currentTarget.getAttribute('name')
    if (!returnId) return

    this.setState({ isLoading: true })
    InboxCli.DownloadFeedbackFile(returnId).then((error) => {
      if (error) this.setState({ errormessage: error.substring(error.indexOf(' ')), severity: "error" })
      else this.setState({ errormessage: null })
      
      this.setState({ isLoading: false })
    })
  }

  /**
   * Download original document of shipment
   */
  downloadDocument = () => {
    this.downloadShipmentDocumentOfBillable()
  }

  downloadShipmentDocumentOfBillable = () => {
    this.setState({ isLoading: true })
    OutboxCli.DownloadShipmentDocumentOfBillable(this.state.shipment.shipmentCode).then((error) => {
      if (error) this.setState({ errormessage: error.substring(error.indexOf(' ')) })
      else this.setState({ errormessage: null })
      
      this.setState({ isLoading: false })
    })
  }
  
  bytesToBestMagnitude = (len) => {
    let sizes = ["B", "KB", "MB", "GB", "TB"]
    let order = 0;
    while (len >= 1024 && order < sizes.length - 1) {
      order++;
      len = len / 1024;
    }
   
    let newLen = (Math.round(len * 100) / 100).toFixed(1) + " " + sizes[order]
    return newLen
  }

  getDocumentPages = () => {
    if (!this.state.shipment) return 0
    if (!this.state.shipment.features) return 0
    
    let documentPages = 0;
    this.state.shipment.pages.forEach(p => { documentPages += p.pageLast - p.pageFirst + 1; });
    return documentPages;
  }
  

  render() {
    const printColor = this.state.shipment && this.state.shipment.features ? (this.state.shipment.features.printColor ? localizer.Colour : localizer.Gray) : ""
    const printDuplex = this.state.shipment && this.state.shipment.features ? (this.state.shipment.features.printDuplex ? localizer.Duplex : localizer.Simplex) : ""
    const printType = printColor + " - " + printDuplex
    const pages = this.getDocumentPages()

    const url = this.getUrlOperator(this.state.trackingMain)
    const labelEmissionTime = this.state.shipment ? (this.state.shipment.emissionTime !== null && new Date(this.state.shipment.emissionTime) > Date.now()) ? localizer.InboxDateProgrammed : localizer.InboxDateEmission : null
    const trackingNA = this.state.shipment && this.state.shipment.dequeuedTime && !this.state.trackingMain ? "N/A" : null
   
    return (
      <React.Fragment>
        <TableRowStyled>
          <TableCellStyled align="center" style={{ width: 48 }}>
            <Tooltip className="typography-generic" title={<Typography className="typography-generic">{this.state.open ? localizer.ExpandLess : localizer.ExpandMore}</Typography>}>
              <IconButton aria-label="expand row" size="small" onClick={this.setOpen}>
                {this.state.open ? <i className="fa-solid fa-angle-up font-size-20"></i> : <i className="fa-solid fa-angle-down font-size-20"></i>}
              </IconButton>
            </Tooltip>
          </TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center">{this.state.shipment ? DateCustom.convertUTCToLocalTime(this.state.shipment.emissionTime) : ""}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center">{this.state.shipment ? this.state.shipment.billableCode : ""}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center">{this.state.shipment ? this.state.shipment.ownerUser : ""}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content font-weight-bold" align="center">{this.state.shipment ? this.state.shipment.shipmentCode : ""}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center">{this.state.shipment && this.state.shipment.features ? this.getProductDescription(this.state.shipment.features.productCode) : ""}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center">{printType}</TableCellStyled>
          {/* Rows commented below need to be used when atributes firstPageCost and nextPageCost are implemented */}
          {/* <TableCell className="typography-generic tablerow-content" align="center">{this.state.shipment ? this.state.shipment.firstPageCost : ""}</TableCell>
          <TableCell className="typography-generic tablerow-content" align="center">{this.state.shipment ? this.state.shipment.nextPagesCost : ""}</TableCell> */}
          <TableCellStyled className="typography-generic tablerow-content" align="center">{pages}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center">{this.state.shipment && this.state.shipment.features ? CurrencyCustom.currencyFormatter(CurrencyCustom.CURRENCIES.EUR, this.state.shipment.features.price / 100) : ""}</TableCellStyled>
        </TableRowStyled>

        {/* Collapse row */}
        <TableRow>
          <TableCellStyled style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={13}>
            <Collapse in={this.state.open} timeout="auto" unmountOnExit>
              <Grid container direction="row" style={{ borderBottom: "1px solid #DADADA" }}>
                <Grid item md={4} style={{ borderRight: "1px solid #DADADA" }}>
                  <Grid item md={12}>
                    <Typography className="typography-generic bigweight secondary">{localizer.InboxChronology}</Typography>
                  </Grid>
                  <hr className="hr-custom"></hr>
                  {this.state.shipment &&
                    <Grid container item md={12}>
                      <Grid item md={5}><Typography className="typography-generic small">{DateCustom.convertUTCToLocalTime(this.state.shipment.emissionTime)}</Typography></Grid>
                      <Grid item md={7}><Typography className="typography-generic small bigweight">{labelEmissionTime}</Typography></Grid>
                    </Grid>
                  }
                  {this.state.states && this.state.states.slice(-3).map((state, index) => {
                    let stateCode = StateCodes.CODES.find(c => c.stateCode === state.stateCode)
                    let stateName = stateCode ? stateCode.name : null
                    return (
                      <Grid container item md={12} key={state.returnId}>
                        <Grid item md={5}><Typography className="typography-generic small pb-0 pt-0">{DateCustom.convertUTCToLocalTime(state.timestamp)}</Typography></Grid>
                        <Grid item md={7}>
                          <Typography className="typography-generic small bigweight pb-0 pt-0">
                            {stateName}
                          </Typography>
                          <Typography className="typography-generic xsmall  pb-0 pt-0">
                            {state.stateData.Details ? state.stateData.Description + " - " + state.stateData.Details : state.stateData.Description}
                          </Typography>
                        </Grid>
                      </Grid>
                    )
                  }
                  )}
                  {this.state.trackingMain &&
                    <Grid container direction="row" className="mt-15">
                      <Grid item md={12} >
                        <Grid item md={12}>
                          <Typography className="typography-generic bigweight secondary"> {localizer.Tracking}: </Typography></Grid>
                      </Grid>
                      <Grid container item md={12}>
                        <Grid item md={5}><Typography className="typography-generic small pb-0 pt-0">{DateCustom.convertUTCToLocalTime(this.state.trackingMain.assignedTime)}</Typography></Grid>
                        <Grid item md={7}><Typography className="typography-generic small bigweight  pb-0 pt-0"><a href={url} className="link-hover" target="_blank" rel="noreferrer">{this.state.trackingMain.codeValue}</a></Typography></Grid>
                      </Grid>
                    </Grid>
  
                  }
                  {trackingNA !== null &&
                    <Grid container direction="row" className="mt-15">
                      <Grid item md={12} >
                        <Typography className="typography-generic bigweight secondary"> {localizer.Tracking}: {trackingNA}</Typography></Grid>
                      
                    </Grid>
  
                  }
                  {this.state.trackingsDispatches && this.state.trackingsDispatches.length !== 0 &&
                    <Grid container item md={12} className="mt-15">
                      <Grid item md={12}>
                        <Typography className="typography-generic bigweight secondary"> {localizer.ReDispatches}: </Typography>
                        <hr className="hr-custom" />
                      </Grid>
                      {this.state.trackingsDispatches && this.state.trackingsDispatches.map(t => {
                        let url = this.getUrlOperator(t)
                        return (
                          <Grid container item md={12}>
                            <Grid item md={5}><Typography className="typography-generic small pb-0 pt-0">{DateCustom.convertUTCToLocalTime(t.assignedTime)}</Typography></Grid>
                            <Grid item md={7}><Typography className="typography-generic small bigweight  pb-0 pt-0"><a href={url} className="link-hover" target="_blank" rel="noreferrer">{t.codeValue}</a></Typography></Grid>
                          </Grid>

                        )
                      })
                      }
                    </Grid>
                  }
                </Grid>
                <Grid item md={4} style={{ borderRight: "1px solid #DADADA" }}>
                  <Grid item md={12}>
                    <Typography className="typography-generic bigweight secondary">{localizer.InboxShipmentInfo}</Typography>
                  </Grid>
                  <hr className="hr-custom"></hr>
                  <Grid container item md={12}>
                    <Grid item md={4}><Typography className="typography-generic small bigweight">{localizer.InboxShipmentType}:</Typography></Grid>
                    <Grid item md={8}><Typography className="typography-generic small">{(this.state.shipment && this.state.shipment.features) ? this.getProductDescription(this.state.shipment.features.productCode) : ""}</Typography></Grid>
                  </Grid>
                  <Grid container item md={12}>
                    <Grid item md={4}><Typography className="typography-generic small bigweight">{localizer.InboxDestination}:</Typography></Grid>
                    <Grid item md={8}>
                      <Typography className="typography-generic small white-space-pre pb-0 pt-0">{this.mountDestinationAddress()}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item md={4}>
                  <Grid item md={12}>
                    <Typography className="typography-generic bigweight secondary">{localizer.InboxDocuments}</Typography>
                  </Grid>
                  <hr className="hr-custom"></hr>
                  <Grid container item md={12}>
                    <Grid item md={9}>
                      <Typography className="typography-generic small textinline bigweight link-hover" onClick={this.downloadDocument}>{localizer.InboxDocumentOriginal}</Typography>
                      <Typography className="typography-generic xsmall m-0 pt-0">{this.state.shipment ? DateCustom.convertUTCToLocalTime(this.state.shipment.emissionTime) : ""}</Typography>
                    </Grid>
                    <Grid item md={3} className="text-align-right mt-5" >
                      <Chip className="document-tag ml-5" icon={<i className="fa-solid fa-file-lines font-size-12 color-document-icon" />} variant="outlined" label={<Typography className="typography-generic xsmall font-weight-bold">{localizer.InboxDocument}</Typography>} />
                    </Grid>
                  </Grid>
                  {this.state.documents && this.state.documents.map((document) => {
                    let size = document !== null ? this.bytesToBestMagnitude(document.documentSize) : 0
                    return (
                      <Grid container item md={12} key={document.returnId} direction="row">
                        <Grid item md={9} className="m-0 pt-0">
                          <Typography name={document.returnId} className="typography-generic small textinline bigweight link-hover" onClick={this.downloadFeedbackFile}>{document.documentFileName}</Typography>
                          <Typography className="typography-generic xsmall m-0 pt-0"><strong>{localizer.Date}</strong>:&nbsp;{DateCustom.convertUTCToLocalTime(document.timestamp)}&nbsp; &nbsp; <strong>{localizer.Size}</strong>:&nbsp;{size} </Typography>
                        </Grid>
                        
                        <Grid item md={3} className="text-align-right mt-5">
                          <Chip className="document-tag ml-5" icon={<i className="fa-solid fa-file-lines font-size-12 color-document-icon" />} variant="outlined" label={<Typography className="typography-generic xsmall font-weight-bold">{localizer.InboxDocument}</Typography>} />
                        </Grid>
                      </Grid>
                    )
                  })}
                  {this.state.stampedCopies && this.state.stampedCopies.map((stampedCopy) => {
                    let size = stampedCopy !== null ? this.bytesToBestMagnitude(stampedCopy.documentSize) : 0
                    return (
                      <Grid container item md={12} key={stampedCopy.returnId} direction="row">
                        <Grid item md={9} className="m-0 pt-0">
                          <Typography name={stampedCopy.returnId} className="typography-generic small textinline bigweight link-hover" onClick={this.downloadFeedbackFile}>{stampedCopy.documentFileName}</Typography>
                          <Typography className="typography-generic xsmall m-0 pt-0"><strong>{localizer.Date}</strong>:&nbsp;{DateCustom.convertUTCToLocalTime(stampedCopy.timestamp)}&nbsp; &nbsp; <strong>{localizer.Size}</strong>:&nbsp;{size} </Typography>
                        </Grid>

                        <Grid item md={3} className="text-align-right mt-5">
                          <Chip className="document-tag ml-5" icon={<i className="fa-solid fa-stamp font-size-12 color-document-icon" />} variant="outlined" label={<Typography className="typography-generic xsmall font-weight-bold">{localizer.InboxStampedCopy}</Typography>} />
                        </Grid>
                      </Grid>
                    )
                  })}
                  {this.state.proofs && this.state.proofs.map((proof) => {
                    let size = proof !== null ? this.bytesToBestMagnitude(proof.documentSize) : 0
                    return (
                      <Grid container item md={12} key={proof.returnId}>
                        <Grid item md={9}>
                          <Typography className="typography-generic small textinline bigweight link-hover" name={proof.returnId} onClick={this.downloadFeedbackFile}>{proof.documentFileName}</Typography>
                          <Typography className="typography-generic xsmall m-0 pt-0"><strong>{localizer.Date}</strong>:&nbsp;{DateCustom.convertUTCToLocalTime(proof.timestamp)}&nbsp; &nbsp; <strong>{localizer.Size}</strong>:&nbsp;{size} </Typography>
                        </Grid>
                        <Grid item md={3} className="text-align-right mt-5">
                          <Chip className="proof-tag ml-5" icon={<i className="fa-solid fa-file-lines font-size-12 color-proof-icon" />} variant="outlined" label={<Typography className="typography-generic xsmall font-weight-bold">{localizer.InboxProof}</Typography>} name={proof.returnId} />
                        </Grid>
                      </Grid>
                    )
                  })}
                  {this.state.certs && this.state.certs.map((cert, index) => {
                    let size = cert !== null ? this.bytesToBestMagnitude(cert.documentSize) : 0
                    return (
                      <Grid container item md={12} key={cert.returnId}>
                        <Grid item md={9}>
                          <Typography className="typography-generic small textinline bigweight link-hover" name={cert.returnId} onClick={this.downloadFeedbackFile}>{cert.documentFileName}</Typography>
                          <Typography className="typography-generic xsmall m-0 pt-0"><strong>{localizer.Date}</strong>:&nbsp;{DateCustom.convertUTCToLocalTime(cert.timestamp)}&nbsp; &nbsp; <strong>{localizer.Size}</strong>:&nbsp;{size} </Typography>
                        </Grid>
                        <Grid item md={3} className="text-align-right mt-5">
                          <Chip className="cert-tag ml-5" icon={<i className="fa-solid fa-certificate font-size-12 color-cert-icon" />} variant="outlined" label={<Typography className="typography-generic xsmall font-weight-bold">{localizer.InboxCert}</Typography>} name={cert.returnId} />
                        </Grid>
                      </Grid>
                    )
                  })}
                </Grid>
              </Grid>
              <Grid container direction="row" style={{ padding: "5px" }}>
                <Grid item md={11} style={{ maxHeight: 50 }}></Grid>
                <Grid item md={1} style={{ maxHeight: 50 }}>
                  <Button className="button-generic card font-size-12" variant="outlined" size="small" onClick={this.handleOpenModal}>{localizer.InboxViewAll}</Button>
                </Grid>

              </Grid>
            </Collapse>
          </TableCellStyled>
        </TableRow>

        {/* Shipment summary dialog */}
        {this.state.openModal &&
          <FeedbackShipmentSummary shipmentCode={this.state.shipment.shipmentCode} openModal={this.state.openModal} trackingMain={this.state.trackingMain} trackingsDispatches={this.state.trackingsDispatches} handleCloseModal={this.handleCloseModal}></FeedbackShipmentSummary>
        }

        {/* Upload draft error. */}
        <SnackbarCustom message={this.state.errormessage} severity={this.state.severity} handleonClose={() => { this.setState({ errormessage: null }) }} />

        {/* Waiting for service response. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 1350 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/billing/sections/BillingShipmentRow.js